module.exports = __webpack_public_path__ + "static/media/icon-star-white.75271351.svg";